// src/steps/PixStep.js
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useCheckout } from "../CheckoutContext";
import toast from "react-hot-toast";

export default function PixStep() {
  
  const { pixQrCode, pixCopyPaste } = useCheckout();

  function copiarCodigo() {
    navigator.clipboard.writeText(pixCopyPaste);
    toast.success("Código PIX copiado!");
  }

  return (
    <Box textAlign="center">
      <Typography variant="h6" gutterBottom>
        Pagamento via PIX
      </Typography>

      {pixQrCode && (
        <img
          src={pixQrCode}
          alt="QR Code PIX"
          style={{ maxWidth: 260 }}
        />
      )}

      <Button fullWidth sx={{ mt: 2 }} onClick={copiarCodigo}>
        Copiar código PIX
      </Button>

      <Typography sx={{ mt: 2 }}>
        Aguardando confirmação do pagamento...
      </Typography>
      <Typography sx={{ pt: 4, maxWidth: 360, margin: "auto", textAlign: "justify" }}>
        Pedimos encarecidamente que gravem um vídeo antes de abrir cada produto, com a caixa ainda da transportadora, e realizem o teste do produto em vídeo. Não utilizaremos a imagem de ninguém caso venha a aparecer no vídeo; o mesmo será usado somente para fins de controle e troca!
      </Typography>
    </Box>
  );
}
